import {Injectable} from '@angular/core';
import {VisbosService} from '../../../core/visbos-core/graphql/visbos.service';
import {Apollo} from 'apollo-angular';
import {NgRedux} from '@angular-redux/store';
import {IAppState} from '../../../shared/redux-store';
import {SessionActions} from '../../../shared/actions';
import {BehaviorSubject} from 'rxjs';
import {ILocation} from '../../../shared/view-model/ilocation.interface';
import {AssetTree} from '../../../shared/view-model/store-management/asset-tree.type';
import {AssetService} from './asset.service';

@Injectable()
export class LocationMarriageWizardService extends VisbosService {

  private _currentLocation: BehaviorSubject<ILocation> = new BehaviorSubject<ILocation>(null);
  private _currentAssetTree: BehaviorSubject<AssetTree[]> = new BehaviorSubject([]);
  private _activeEpcs: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions,
              private assetService: AssetService) {
    super(apollo, ngRedux, sessionActions);
  }

  get currentLocation(): ILocation {
    return this._currentLocation.value;
  }

  get currentLocation$(): BehaviorSubject<ILocation> {
    return this._currentLocation;
  }

  set currentLocation(value: ILocation) {
    this._currentLocation.next(value);
  }

  get currentAssetTree(): AssetTree[] {
    return this._currentAssetTree.value;
  }

  get currentAssetTree$(): BehaviorSubject<AssetTree[]> {
    return this._currentAssetTree;
  }

  set currentAssetTree(value: AssetTree[]) {
    this._currentAssetTree.next(value);
  }

  get activeEpcs(): string[] {
    return this._activeEpcs.value;
  }

  get activeEpcs$(): BehaviorSubject<string[]> {
    return this._activeEpcs;
  }

  set activeEpcs(value: string[]) {
    this._activeEpcs.next(value);
  }

  assignLocationToAssets() {
    return this.assetService.assignLocationToAssets({
      locationCuid: this.currentLocation.cuid,
      locationType: this.currentLocation.__typename,
      assetCuids: this.getCurrentChildrenCuids()
    });
  }

  getCurrentChildrenCuids() {
    const deepMap = (array: AssetTree[], result: string[]) => {
      array.forEach(function (el) {
        result.push(el.cuid);
        if (el.children && el.children.length) {
          deepMap(el.children, result);
        }
      });
    }

    const result: string[] = [];
    deepMap(this.currentAssetTree, result);

    return result;
  }


  resetWizard() {
    this.activeEpcs = [];
    this.currentAssetTree = [];
    this.currentLocation = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/services/location-marriage-wizard.service.ts